import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  PROJECT_STATUS_APROVADO,
  PROJECT_STATUS_PENDENTE,
  PROJECT_STATUS_RASCUNHO,
  PROJECT_STATUS_REJEITADO,
} from '../../library/ProjectStatus';
import { GenericModal } from '../GenericModal';
import EvaluationItem from './EvaluationItem';
import { closeModal } from '../../store/modules/ModalActions';

class EvaluationHistoryModal extends Component {
  getTitle() {
    return (
      <>
        {this.props.languageValues.modalEvaluationHistoryTitle}:<br />
        <small>{this.props.title}</small>
      </>
    );
  }

  getStepStatus() {
    if (
      this.props.projeto.avaliacoes &&
      this.props.projeto.avaliacoes.length > 0
    ) {
      return this.props.projeto.avaliacoes[this.props.stepIndex].status;
    }
    return -1;
  }

  buttonIsAvaliable() {
    const status = this.getStepStatus();
    switch (status) {
      case PROJECT_STATUS_PENDENTE:
      case PROJECT_STATUS_APROVADO:
      case PROJECT_STATUS_REJEITADO:
        return true;
      case PROJECT_STATUS_RASCUNHO:
      default:
        return false;
    }
  }

  render() {
    return this.buttonIsAvaliable() ? (
      <GenericModal
        onClose={() => {
          this.props.closeModal(this.props.modalKey);
        }}
        DialogProps={{
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        }}
        title={this.getTitle()}
      >
        {this.props.history.map((item, index) => {
          return (
            <EvaluationItem
              historyItem={
                this.props.history[this.props.history.length - 1 - index]
              }
              index={index}
              key={index}
            />
          );
        })}
      </GenericModal>
    ) : (
      ''
    );
  }
}

EvaluationHistoryModal.propTypes = {
  stepIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  history: PropTypes.array.isRequired,
  modalKey: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationHistoryModal);
